import {
  ProductIDOptionsType
} from 'src/interfaces/idashboard';

export const stripeConfig = {
  airbtics_uk: {
    promiseKey: 'pk_live_fzoAY4sM0rn3lvlOO27uuf3q00oSVP9TsO',
    promiseKeyTest: 'pk_test_dZkzEKTYsZnflrkfbtjGQVz300NSQzQZDS',
    productIDOptions: {
      pro: {
        productID: {
          monthly: 'price_1PNvF6BVoeq938b5bdLIXOCu',
          yearly: 'price_1PNvUUBVoeq938b5EdlyQjQI',
        },
      },
      expert: {
        productID: {
          monthly: 'price_1PNuokBVoeq938b5oAZLxJeH',
          yearly: 'price_1PNuxhBVoeq938b57qNUXqoX',
        },
      },
      scale: {
        productID: {
          monthly: 'price_1PvFTaBVoeq938b5gQ8nvhOd',
          yearly: 'price_1PvFURBVoeq938b5GDURLWaw',
        },
      },
    },
    testProductIDOptions: {
      expert: {
        productID: {
          monthly: 'price_1RnZU8BVoeq938b5ACMiO9HG',
          yearly: 'price_1RnfkcBVoeq938b5TPWIlfMj',
        },
      },
      scale: {
        productID: {
          monthly: 'price_1RvdzXBVoeq938b5RWe3gNFy',
          yearly: 'price_1Rve0pBVoeq938b5CGW5qmB4',
        },
      },
    },
  },
  airbtics_us: {
    promiseKey: 'pk_live_51RNorCIMlZIXoKUqxbjj8Ju5vfGg2OHOHOZdyUkIOHJ11EmbJL3mROfKasBElL2XM7U7UciMgz3sMsPEbwJxYZiT00Id6Q9d0Y',
    promiseKeyTest: 'pk_test_51RNorCIMlZIXoKUqRs6dDzDjDQhy6G6Oat2pejHE6uefzaMYgFQ0URXKnit70Eik2ZBHINgWgXMLog7mIcfHskML00Ke4Ic7mz',
    productIDOptions: {
      expert: {
        productID: {
            monthly: 'price_1RfbehIMlZIXoKUqbfXFwmbl',
            yearly: 'price_1RfbgUIMlZIXoKUqYL6MieMR',
        },
      },
      scale: {
        productID: {
          monthly: 'price_1RfblQIMlZIXoKUqjZFryTxi',
          yearly: 'price_1RfbmKIMlZIXoKUqWTMOumg6',
        },
      },
    },
    testProductIDOptions: {
      expert: {
        productID: {
          monthly: 'price_1RvZaUIMlZIXoKUqX2dj8aHX',
          yearly: 'price_1RvZYrIMlZIXoKUq4xb8BOmm',
        },
      },
      scale: {
        productID: {
          monthly: 'price_1Rfg88IMlZIXoKUqNM6tX1J3',
          yearly: 'price_1RvbzoIMlZIXoKUqdadWDT9u',
        },
      },
    },
  },
};


export const listingsExportPricesUSD = {
  tier1: {
    '1': {
      price: 150,
      priceID: 'price_1PhrlTBVoeq938b5vrNf3SBy',
    },
    '2': {
      price: 300,
      priceID: 'price_1Phrn4BVoeq938b5beJ29jFf',
    },
    '3': {
      price: 450,
      priceID: 'price_1PhrodBVoeq938b5fc5Qhu6h',
    },
  },
  tier2: {
    '1': {
      price: 300,
      priceID: 'price_1Phrn4BVoeq938b5beJ29jFf',
    },
    '2': {
      price: 600,
      priceID: 'price_1PhrowBVoeq938b5ggB1RZ4Q',
    },
    '3': {
      price: 900,
      priceID: 'price_1PhrpIBVoeq938b5A8iCjGcD',
    },
  },
  tier3: {
    '1': {
      price: 500,
      priceID: 'price_1PhrnjBVoeq938b5rPnrHKee',
    },
    '2': {
      price: 1000,
      priceID: 'price_1PhrpfBVoeq938b5n2V0p1jk',
    },
    '3': {
      price: 1500,
      priceID: 'price_1PhrpxBVoeq938b5iwwLDPfO',
    },
  },
};

export const ProductIDOptions: ProductIDOptionsType = {
  pro: {
    productID: {
      monthly: 'price_1PNvF6BVoeq938b5bdLIXOCu',
      yearly: 'price_1PNvUUBVoeq938b5EdlyQjQI',
    },
  },
  expert: {
    productID: {
      monthly: 'price_1PNuokBVoeq938b5oAZLxJeH',
      yearly: 'price_1PNuxhBVoeq938b57qNUXqoX',
    },
  },
  scale: {
    productID: {
      monthly: 'price_1PvFTaBVoeq938b5gQ8nvhOd',
      yearly: 'price_1PvFURBVoeq938b5GDURLWaw',
    },
  },
};
